// Lib
import { makeStyles } from 'tss-react/mui';

import { pickIf } from '../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { styles, isFullScreen, padding, right, top } = {}) => ({
    root: {
      backgroundColor: 'white',
      borderRadius: 20,
      left: '50%',
      minHeight: 200,
      outline: 0,
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      ...(!isFullScreen && {
        height: 'initial',
        '& #content': {
          minHeight: 'initial',
        },
      }),
      ...styles,
      ...(isFullScreen && {
        borderRadius: 0,
        height: ['100vh', 'calc(var(--vh, 1vh) * 100)'],
        width: '100vw',

        '& #content': {
          minHeight: [
            '100vh',
            'calc(var(--vh, 1vh) * 100)',
            '-moz-available',
            '-webkit-fill-available',
            'fill-available',
          ],
        },
      }),
    },
    addressSavedCard: {
      borderRadius: '10px !important',
      minHeight: 'initial !important',
      textAlign: 'center',
      width: '280px !important',
      [theme.breakpoints?.down('md')]: {
        width: '230px !important',
        padding: 6,
        '& .MuiTypography-root': {
          fontSize: 14,
        },
      },
      [theme.breakpoints?.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: '230px !important',
          padding: 6,
          '& .MuiTypography-root': {
            fontSize: 14,
          },
        }),
      },
    },
    contentContainer: {
      height: '100%',
      overflowY: 'auto',
      maxHeight: [
        pickIf(isFullScreen, '100vh', '90vh'),
        pickIf(
          isFullScreen,
          'calc(var(--vh, 1vh) * 100)',
          'calc(var(--vh, 1vh) * 90)',
        ),
      ],
      position: 'relative',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      // stretch modal content on full height to be able to move buttons down
      height: '100%',
      padding: padding.xl,
      [theme.breakpoints.down('lg')]: {
        padding: padding.lg,
      },
      [theme.breakpoints.down('md')]: {
        padding: padding.md,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          padding: padding.lg,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          padding: padding.md,
        }),
      },
    },
    backdrop: {
      backgroundColor: theme.palette.blured,
    },
    titleContainer: {
      backgroundColor: 'white',
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      position: 'sticky',
      top: 0,
      width: '100%',
      zIndex: 1,
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
      margin: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: 22,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 22,
        }),
      },
    },
    closeButton: {
      right: right.xl,
      top: top.xl,
      [theme.breakpoints.down('lg')]: {
        right: right.lg,
        top: top.lg,
      },
      [theme.breakpoints.down('md')]: {
        right: right.md,
        top: top.md,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          right: right.lg,
          top: top.lg,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          right: right.md,
          top: top.md,
        }),
      },
    },
  }),
);
